import { IAuthActionTypes, IAuthActionCreator, IAuthState } from 'models/IAuthState';

const initialState: IAuthState = {
  user: null,
  role: null,
  error: null,
  state: null,
};

const reducer = (state = initialState, { type, payload }: IAuthActionCreator) => {
  console.log('auth reducer: ', { type, payload });

  switch (type) {
    case IAuthActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        user: payload.user,
        role: payload.role,
        state: payload.state,
        error: null,
      };
    case IAuthActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        user: null,
        state: payload.state,
        error: payload.error,
      };
    case IAuthActionTypes.LOGOUT:
      return {
        ...state,
        user: null,
        role: null,
        error: null,
        state: null,
      };
    case IAuthActionTypes.SILENT_LOGIN:
      return {
        ...state,
        user: payload.user,
        role: payload.role,
        state: payload.state,
        error: null,
      };
    default:
      return state;
  }
};

export default reducer;
